<ng-template #choicesiterator let-choices>
    @for (k of objectKeys(choices); track k) {
        @if (choices[k].choices) {
            <div (click)="checkGroup(choices[k].choices)" class="option label">
                @if (multiple) {
                    <input type="checkbox" [checked]="isSelectedGroup(choices[k].choices)" />
                }
                <i class="fa {{ choices[k].label }}"></i>
            </div>
            <div class="choice-group">
                <ng-template [ngTemplateOutlet]="choicesiterator" [ngTemplateOutletContext]="{ $implicit: choices[k].choices }"> </ng-template>
            </div>
        }
        @if (!choices[k].choices) {
            <div (click)="checkValue(choices[k].value)" class="option choice" [class.errors]="view?.vars?.errors.length" [title]="choices[k].value">
                <input [type]="multiple ? 'checkbox' : 'radio'" [checked]="isSelected(choices[k].value)" />
                <i style="font-size: 2rem" class="fa {{ choices[k].label }}"></i>
            </div>
        }
    }
</ng-template>

<ng-template [ngTemplateOutlet]="choicesiterator" [ngTemplateOutletContext]="{ $implicit: choices }"> </ng-template>
